import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _get from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { __rest } from '../../_virtual/_tslib.js';
import * as index from '../../crypto/index.js';
import { httpRequest } from '../../http/request.js';
import { PromiseQueue } from '../../util/PromiseQueue.js';
import { isFunction } from '../../util/types.js';
import 'tiny-emitter';
import 'js-cookie';
import AuthSdkError from '../../errors/AuthSdkError.js';
import 'cross-fetch';
import PKCE from '../util/pkce.js';
import { createTokenAPI, createEndpoints } from '../factory/api.js';
import { TokenManager } from '../TokenManager.js';
import WWWAuthError from '../../errors/WWWAuthError.js';
import { getOAuthUrls } from '../util/oauth.js';
import { isLoginRedirect as _isLoginRedirect, hasResponseType as _hasResponseType } from '../util/loginRedirect.js';
import '../types/Token.js';
import { clearDPoPKeyPairAfterRevoke, clearDPoPKeyPair, findKeyPair, generateDPoPProof, clearAllDPoPKeyPairs, isDPoPNonceError } from '../dpop.js';
import { provideOriginalUri } from './browser.js';
function mixinOAuth(Base, TransactionManagerConstructor) {
  var _a;
  var WithOriginalUri = provideOriginalUri(Base);
  return _a = /*#__PURE__*/function (_WithOriginalUri) {
    function OktaAuthOAuth() {
      var _this;
      _classCallCheck(this, OktaAuthOAuth);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, OktaAuthOAuth, [].concat(args));
      _this.transactionManager = new TransactionManagerConstructor(Object.assign({
        storageManager: _this.storageManager
      }, _this.options.transactionManager));
      _this.pkce = {
        DEFAULT_CODE_CHALLENGE_METHOD: PKCE.DEFAULT_CODE_CHALLENGE_METHOD,
        generateVerifier: PKCE.generateVerifier,
        computeChallenge: PKCE.computeChallenge
      };
      _this._pending = {
        handleLogin: false
      };
      _this._tokenQueue = new PromiseQueue();
      _this.token = createTokenAPI(_this, _this._tokenQueue);
      _this.tokenManager = new TokenManager(_this, _this.options.tokenManager);
      _this.endpoints = createEndpoints(_this);
      return _this;
    }
    _inherits(OktaAuthOAuth, _WithOriginalUri);
    return _createClass(OktaAuthOAuth, [{
      key: "clearStorage",
      value: function clearStorage() {
        _superPropGet(OktaAuthOAuth, "clearStorage", this, 3)([]);
        this.tokenManager.clear();
      }
    }, {
      key: "isAuthenticated",
      value: function () {
        var _isAuthenticated = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var options,
            _this$tokenManager$ge,
            autoRenew,
            autoRemove,
            shouldRenew,
            shouldRemove,
            _this$tokenManager$ge2,
            accessToken,
            _this$tokenManager$ge3,
            idToken,
            _args = arguments;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _this$tokenManager$ge = this.tokenManager.getOptions(), autoRenew = _this$tokenManager$ge.autoRenew, autoRemove = _this$tokenManager$ge.autoRemove;
                shouldRenew = options.onExpiredToken ? options.onExpiredToken === 'renew' : autoRenew;
                shouldRemove = options.onExpiredToken ? options.onExpiredToken === 'remove' : autoRemove;
                _this$tokenManager$ge2 = this.tokenManager.getTokensSync(), accessToken = _this$tokenManager$ge2.accessToken;
                if (!(accessToken && this.tokenManager.hasExpired(accessToken))) {
                  _context.next = 19;
                  break;
                }
                accessToken = undefined;
                if (!shouldRenew) {
                  _context.next = 18;
                  break;
                }
                _context.prev = 8;
                _context.next = 11;
                return this.tokenManager.renew('accessToken');
              case 11:
                accessToken = _context.sent;
                _context.next = 16;
                break;
              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](8);
              case 16:
                _context.next = 19;
                break;
              case 18:
                if (shouldRemove) {
                  this.tokenManager.remove('accessToken');
                }
              case 19:
                _this$tokenManager$ge3 = this.tokenManager.getTokensSync(), idToken = _this$tokenManager$ge3.idToken;
                if (!(idToken && this.tokenManager.hasExpired(idToken))) {
                  _context.next = 34;
                  break;
                }
                idToken = undefined;
                if (!shouldRenew) {
                  _context.next = 33;
                  break;
                }
                _context.prev = 23;
                _context.next = 26;
                return this.tokenManager.renew('idToken');
              case 26:
                idToken = _context.sent;
                _context.next = 31;
                break;
              case 29:
                _context.prev = 29;
                _context.t1 = _context["catch"](23);
              case 31:
                _context.next = 34;
                break;
              case 33:
                if (shouldRemove) {
                  this.tokenManager.remove('idToken');
                }
              case 34:
                return _context.abrupt("return", !!(accessToken && idToken));
              case 35:
              case "end":
                return _context.stop();
            }
          }, _callee, this, [[8, 14], [23, 29]]);
        }));
        function isAuthenticated() {
          return _isAuthenticated.apply(this, arguments);
        }
        return isAuthenticated;
      }()
    }, {
      key: "signInWithRedirect",
      value: function () {
        var _signInWithRedirect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var opts,
            originalUri,
            additionalParams,
            params,
            _args2 = arguments;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                opts = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                originalUri = opts.originalUri, additionalParams = __rest(opts, ["originalUri"]);
                if (!this._pending.handleLogin) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return");
              case 4:
                this._pending.handleLogin = true;
                _context2.prev = 5;
                if (originalUri) {
                  this.setOriginalUri(originalUri);
                }
                params = Object.assign({
                  scopes: this.options.scopes || ['openid', 'email', 'profile']
                }, additionalParams);
                _context2.next = 10;
                return this.token.getWithRedirect(params);
              case 10:
                _context2.prev = 10;
                this._pending.handleLogin = false;
                return _context2.finish(10);
              case 13:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this, [[5,, 10, 13]]);
        }));
        function signInWithRedirect() {
          return _signInWithRedirect.apply(this, arguments);
        }
        return signInWithRedirect;
      }()
    }, {
      key: "getUser",
      value: function () {
        var _getUser = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var _this$tokenManager$ge4, idToken, accessToken;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _this$tokenManager$ge4 = this.tokenManager.getTokensSync(), idToken = _this$tokenManager$ge4.idToken, accessToken = _this$tokenManager$ge4.accessToken;
                return _context3.abrupt("return", this.token.getUserInfo(accessToken, idToken));
              case 2:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
        function getUser() {
          return _getUser.apply(this, arguments);
        }
        return getUser;
      }()
    }, {
      key: "getIdToken",
      value: function getIdToken() {
        var _this$tokenManager$ge5 = this.tokenManager.getTokensSync(),
          idToken = _this$tokenManager$ge5.idToken;
        return idToken ? idToken.idToken : undefined;
      }
    }, {
      key: "getAccessToken",
      value: function getAccessToken() {
        var _this$tokenManager$ge6 = this.tokenManager.getTokensSync(),
          accessToken = _this$tokenManager$ge6.accessToken;
        return accessToken ? accessToken.accessToken : undefined;
      }
    }, {
      key: "getRefreshToken",
      value: function getRefreshToken() {
        var _this$tokenManager$ge7 = this.tokenManager.getTokensSync(),
          refreshToken = _this$tokenManager$ge7.refreshToken;
        return refreshToken ? refreshToken.refreshToken : undefined;
      }
    }, {
      key: "getOrRenewAccessToken",
      value: function () {
        var _getOrRenewAccessToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var _a, _this$tokenManager$ge8, accessToken, key, token;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _this$tokenManager$ge8 = this.tokenManager.getTokensSync(), accessToken = _this$tokenManager$ge8.accessToken;
                if (!(accessToken && !this.tokenManager.hasExpired(accessToken))) {
                  _context4.next = 3;
                  break;
                }
                return _context4.abrupt("return", accessToken.accessToken);
              case 3:
                _context4.prev = 3;
                key = this.tokenManager.getStorageKeyByType('accessToken');
                _context4.next = 7;
                return this.tokenManager.renew(key !== null && key !== void 0 ? key : 'accessToken');
              case 7:
                token = _context4.sent;
                return _context4.abrupt("return", (_a = token === null || token === void 0 ? void 0 : token.accessToken) !== null && _a !== void 0 ? _a : null);
              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](3);
                this.emitter.emit('error', _context4.t0);
                return _context4.abrupt("return", null);
              case 15:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this, [[3, 11]]);
        }));
        function getOrRenewAccessToken() {
          return _getOrRenewAccessToken.apply(this, arguments);
        }
        return getOrRenewAccessToken;
      }()
    }, {
      key: "storeTokensFromRedirect",
      value: function () {
        var _storeTokensFromRedirect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          var _yield$this$token$par, tokens, responseType;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.token.parseFromUrl();
              case 2:
                _yield$this$token$par = _context5.sent;
                tokens = _yield$this$token$par.tokens;
                responseType = _yield$this$token$par.responseType;
                if (responseType !== 'none') {
                  this.tokenManager.setTokens(tokens);
                }
              case 6:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
        function storeTokensFromRedirect() {
          return _storeTokensFromRedirect.apply(this, arguments);
        }
        return storeTokensFromRedirect;
      }()
    }, {
      key: "isLoginRedirect",
      value: function isLoginRedirect() {
        return _isLoginRedirect(this);
      }
    }, {
      key: "isPKCE",
      value: function isPKCE() {
        return !!this.options.pkce;
      }
    }, {
      key: "hasResponseType",
      value: function hasResponseType(responseType) {
        return _hasResponseType(responseType, this.options);
      }
    }, {
      key: "isAuthorizationCodeFlow",
      value: function isAuthorizationCodeFlow() {
        return this.hasResponseType('code');
      }
    }, {
      key: "invokeApiMethod",
      value: function () {
        var _invokeApiMethod = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(options) {
          var accessToken;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                if (options.accessToken) {
                  _context6.next = 5;
                  break;
                }
                _context6.next = 3;
                return this.tokenManager.getTokens();
              case 3:
                accessToken = _context6.sent.accessToken;
                options.accessToken = accessToken === null || accessToken === void 0 ? void 0 : accessToken.accessToken;
              case 5:
                return _context6.abrupt("return", httpRequest(this, options));
              case 6:
              case "end":
                return _context6.stop();
            }
          }, _callee6, this);
        }));
        function invokeApiMethod(_x) {
          return _invokeApiMethod.apply(this, arguments);
        }
        return invokeApiMethod;
      }()
    }, {
      key: "revokeAccessToken",
      value: function () {
        var _revokeAccessToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(accessToken) {
          var tokens, accessTokenKey;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                if (accessToken) {
                  _context7.next = 10;
                  break;
                }
                _context7.next = 3;
                return this.tokenManager.getTokens();
              case 3:
                tokens = _context7.sent;
                accessToken = tokens.accessToken;
                accessTokenKey = this.tokenManager.getStorageKeyByType('accessToken');
                this.tokenManager.remove(accessTokenKey);
                if (!this.options.dpop) {
                  _context7.next = 10;
                  break;
                }
                _context7.next = 10;
                return clearDPoPKeyPairAfterRevoke('access', tokens);
              case 10:
                if (accessToken) {
                  _context7.next = 12;
                  break;
                }
                return _context7.abrupt("return", Promise.resolve(null));
              case 12:
                return _context7.abrupt("return", this.token.revoke(accessToken));
              case 13:
              case "end":
                return _context7.stop();
            }
          }, _callee7, this);
        }));
        function revokeAccessToken(_x2) {
          return _revokeAccessToken.apply(this, arguments);
        }
        return revokeAccessToken;
      }()
    }, {
      key: "revokeRefreshToken",
      value: function () {
        var _revokeRefreshToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(refreshToken) {
          var tokens, refreshTokenKey;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                if (refreshToken) {
                  _context8.next = 10;
                  break;
                }
                _context8.next = 3;
                return this.tokenManager.getTokens();
              case 3:
                tokens = _context8.sent;
                refreshToken = tokens.refreshToken;
                refreshTokenKey = this.tokenManager.getStorageKeyByType('refreshToken');
                this.tokenManager.remove(refreshTokenKey);
                if (!this.options.dpop) {
                  _context8.next = 10;
                  break;
                }
                _context8.next = 10;
                return clearDPoPKeyPairAfterRevoke('refresh', tokens);
              case 10:
                if (refreshToken) {
                  _context8.next = 12;
                  break;
                }
                return _context8.abrupt("return", Promise.resolve(null));
              case 12:
                return _context8.abrupt("return", this.token.revoke(refreshToken));
              case 13:
              case "end":
                return _context8.stop();
            }
          }, _callee8, this);
        }));
        function revokeRefreshToken(_x3) {
          return _revokeRefreshToken.apply(this, arguments);
        }
        return revokeRefreshToken;
      }()
    }, {
      key: "getSignOutRedirectUrl",
      value: function getSignOutRedirectUrl() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var idToken = options.idToken,
          postLogoutRedirectUri = options.postLogoutRedirectUri,
          state = options.state;
        if (!idToken) {
          idToken = this.tokenManager.getTokensSync().idToken;
        }
        if (!idToken) {
          return '';
        }
        if (postLogoutRedirectUri === undefined) {
          postLogoutRedirectUri = this.options.postLogoutRedirectUri;
        }
        var logoutUrl = getOAuthUrls(this).logoutUrl;
        var idTokenHint = idToken.idToken;
        var logoutUri = logoutUrl + '?id_token_hint=' + encodeURIComponent(idTokenHint);
        if (postLogoutRedirectUri) {
          logoutUri += '&post_logout_redirect_uri=' + encodeURIComponent(postLogoutRedirectUri);
        }
        if (state) {
          logoutUri += '&state=' + encodeURIComponent(state);
        }
        return logoutUri;
      }
    }, {
      key: "signOut",
      value: function () {
        var _signOut = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(options) {
          var _a, defaultUri, currentUri, postLogoutRedirectUri, state, accessToken, refreshToken, revokeAccessToken, revokeRefreshToken, dpopPairId, logoutUri, sessionClosed, redirectUri;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                options = Object.assign({}, options);
                defaultUri = window.location.origin;
                currentUri = window.location.href;
                postLogoutRedirectUri = options.postLogoutRedirectUri === null ? null : options.postLogoutRedirectUri || this.options.postLogoutRedirectUri || defaultUri;
                state = options === null || options === void 0 ? void 0 : options.state;
                accessToken = options.accessToken;
                refreshToken = options.refreshToken;
                revokeAccessToken = options.revokeAccessToken !== false;
                revokeRefreshToken = options.revokeRefreshToken !== false;
                if (revokeRefreshToken && typeof refreshToken === 'undefined') {
                  refreshToken = this.tokenManager.getTokensSync().refreshToken;
                }
                if (revokeAccessToken && typeof accessToken === 'undefined') {
                  accessToken = this.tokenManager.getTokensSync().accessToken;
                }
                if (!options.idToken) {
                  options.idToken = this.tokenManager.getTokensSync().idToken;
                }
                if (!(revokeRefreshToken && refreshToken)) {
                  _context9.next = 15;
                  break;
                }
                _context9.next = 15;
                return this.revokeRefreshToken(refreshToken);
              case 15:
                if (!(revokeAccessToken && accessToken)) {
                  _context9.next = 18;
                  break;
                }
                _context9.next = 18;
                return this.revokeAccessToken(accessToken);
              case 18:
                dpopPairId = (_a = accessToken === null || accessToken === void 0 ? void 0 : accessToken.dpopPairId) !== null && _a !== void 0 ? _a : refreshToken === null || refreshToken === void 0 ? void 0 : refreshToken.dpopPairId;
                if (!(this.options.dpop && dpopPairId)) {
                  _context9.next = 22;
                  break;
                }
                _context9.next = 22;
                return clearDPoPKeyPair(dpopPairId);
              case 22:
                logoutUri = this.getSignOutRedirectUrl(Object.assign(Object.assign({}, options), {
                  postLogoutRedirectUri: postLogoutRedirectUri
                }));
                if (logoutUri) {
                  _context9.next = 33;
                  break;
                }
                _context9.next = 26;
                return this.closeSession();
              case 26:
                sessionClosed = _context9.sent;
                redirectUri = new URL(postLogoutRedirectUri || defaultUri);
                if (state) {
                  redirectUri.searchParams.append('state', state);
                }
                if (postLogoutRedirectUri === currentUri) {
                  window.location.href = redirectUri.href;
                } else {
                  window.location.assign(redirectUri.href);
                }
                return _context9.abrupt("return", sessionClosed);
              case 33:
                if (options.clearTokensBeforeRedirect) {
                  this.tokenManager.clear();
                } else {
                  this.tokenManager.addPendingRemoveFlags();
                }
                window.location.assign(logoutUri);
                return _context9.abrupt("return", true);
              case 36:
              case "end":
                return _context9.stop();
            }
          }, _callee9, this);
        }));
        function signOut(_x4) {
          return _signOut.apply(this, arguments);
        }
        return signOut;
      }()
    }, {
      key: "getDPoPAuthorizationHeaders",
      value: function () {
        var _getDPoPAuthorizationHeaders = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(params) {
          var accessToken, keyPair, proof;
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                if (this.options.dpop) {
                  _context10.next = 2;
                  break;
                }
                throw new AuthSdkError('DPoP is not configured for this client instance');
              case 2:
                accessToken = params.accessToken;
                if (!accessToken) {
                  accessToken = this.tokenManager.getTokensSync().accessToken;
                }
                if (accessToken) {
                  _context10.next = 6;
                  break;
                }
                throw new AuthSdkError('AccessToken is required to generate a DPoP Proof');
              case 6:
                _context10.next = 8;
                return findKeyPair(accessToken === null || accessToken === void 0 ? void 0 : accessToken.dpopPairId);
              case 8:
                keyPair = _context10.sent;
                _context10.next = 11;
                return generateDPoPProof(Object.assign(Object.assign({}, params), {
                  keyPair: keyPair,
                  accessToken: accessToken.accessToken
                }));
              case 11:
                proof = _context10.sent;
                return _context10.abrupt("return", {
                  Authorization: "DPoP ".concat(accessToken.accessToken),
                  Dpop: proof
                });
              case 13:
              case "end":
                return _context10.stop();
            }
          }, _callee10, this);
        }));
        function getDPoPAuthorizationHeaders(_x5) {
          return _getDPoPAuthorizationHeaders.apply(this, arguments);
        }
        return getDPoPAuthorizationHeaders;
      }()
    }, {
      key: "clearDPoPStorage",
      value: function () {
        var _clearDPoPStorage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
          var clearAll,
            _a,
            _b,
            tokens,
            keyPair,
            _args11 = arguments;
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                clearAll = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : false;
                if (!clearAll) {
                  _context11.next = 3;
                  break;
                }
                return _context11.abrupt("return", clearAllDPoPKeyPairs());
              case 3:
                _context11.next = 5;
                return this.tokenManager.getTokens();
              case 5:
                tokens = _context11.sent;
                keyPair = ((_a = tokens.accessToken) === null || _a === void 0 ? void 0 : _a.dpopPairId) || ((_b = tokens.refreshToken) === null || _b === void 0 ? void 0 : _b.dpopPairId);
                if (!keyPair) {
                  _context11.next = 10;
                  break;
                }
                _context11.next = 10;
                return clearDPoPKeyPair(keyPair);
              case 10:
              case "end":
                return _context11.stop();
            }
          }, _callee11, this);
        }));
        function clearDPoPStorage() {
          return _clearDPoPStorage.apply(this, arguments);
        }
        return clearDPoPStorage;
      }()
    }, {
      key: "parseUseDPoPNonceError",
      value: function parseUseDPoPNonceError(headers) {
        var _a;
        var wwwAuth = WWWAuthError.getWWWAuthenticateHeader(headers);
        var wwwErr = WWWAuthError.parseHeader(wwwAuth !== null && wwwAuth !== void 0 ? wwwAuth : '');
        if (isDPoPNonceError(wwwErr)) {
          var nonce = null;
          if (isFunction(headers === null || headers === void 0 ? void 0 : headers.get)) {
            nonce = headers.get('DPoP-Nonce');
          }
          nonce = (_a = nonce !== null && nonce !== void 0 ? nonce : headers['dpop-nonce']) !== null && _a !== void 0 ? _a : headers['DPoP-Nonce'];
          return nonce;
        }
        return null;
      }
    }]);
  }(WithOriginalUri), _a.crypto = index, _a;
}
export { mixinOAuth };